/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable camelcase */

import { ParamType, actions as ACTION } from "./types";

const actions = {
  [ACTION.TRACK_EVENT]({ _ }: any, params: ParamType) {
    return;
  },
};

export default actions;
